import { LOGIN_API_URL, REMEMBER_ME_STORAGE_KEY } from "../../config/constants";

export { LOGIN_API_URL, REMEMBER_ME_STORAGE_KEY };

export const LOGIN_BRAND = {
  title: "Watch Tower",
  subtitle: "Plan. Track. Deliver.",
};

export const LOGIN_COPY = {
  welcome: "Welcome Back!",
  subtitle: "Sign in to access your Watch Tower account.",
};

export const LOGIN_FEATURES = [
  { key: "governance", label: "Project\nGovernance" },
  { key: "tracking", label: "Project\nTracking" },
  { key: "resource", label: "Resource\nManagement" },
  { key: "billing", label: "Milestone\nBilling" },
  { key: "dashboards", label: "Executive\nDashboards" },
];
